/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Answer_3Inputs */

const en_help_center__payments_n_refunds__answer_3 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Answer_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, bid packages are non-refundable once purchased. However, your Bidbattle Loyalty Coins (BLC) never expire and can be used in any future battle to pay for bidpackages. They cannot be transferred to another account or exchanged for cash.`)
};

/**
* | output |
* | --- |
* | "No, bid packages are non-refundable once purchased. However, your Bidbattle Loyalty Coins (BLC) never expire and can be used in any future battle to pay for ..." |
*
* @param {Help_Center__Payments_N_Refunds__Answer_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__answer_3 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Answer_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Answer_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__answer_3(inputs)
});